import { render } from "./Logo.vue?vue&type=template&id=7d84f992"
const script = {}

import exportComponent from "/home/user/Documents/PHP_root/fleet-managment/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__